import styled from 'styled-components'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'

export const TtsContentWrapper = styled.div`
  width: 100%;
  height: 100%;

  display: flex;
  flex-direction: column;
  gap: 11px;

  @media screen and (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    padding-bottom: 8px;
  }
`
